import axios from "axios";

export const listDataVendor = data => axios("data-vendor", { params: data });
export const getDataVendor = data => axios(`data-vendor/${data.id}`);
